export default "__VITE_ASSET__7e3f82a5__"